<template>
  <div
    v-loading="state.loading"
    class="flex items-center justify-center h-full font-bold text-3xl"
  >
    欢迎使用会务管理系统
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({
      loading: true,
    });
    onMounted(() => {
      setTimeout(() => {
        state.loading = false;
      }, 1000);
    });
    return { state };
  },
};
</script>

<style lang="scss" scoped></style>
